module.exports = __webpack_public_path__ + "img/carpet.7f5c3fbc.png";